const base64ToBlob = (base64String: string, mimeType: string) => {
  const bstr = window.atob(base64String)
  let n = bstr.length
  const uBarr = new Uint8Array(n)

  while (n--) {
    uBarr[n] = bstr.charCodeAt(n)
  }
  const blob = new Blob([uBarr], { type: mimeType })
  return blob
}

const saveAs = (dataUri: string, fileName: string) => {
  const link = window.document.createElement('a')
  link.download = fileName
  link.href = dataUri

  window.document.body.appendChild(link)
  link.click()
  window.document.body.removeChild(link)
}

const saveBlob = (blob: Blob, fileName: string, download = true) => {
  if (window.navigator.msSaveOrOpenBlob) {
    // IE10+
    return window.navigator.msSaveOrOpenBlob(blob, fileName)
  }

  const blobUrl = URL.createObjectURL(blob)

  if (download) {
    saveAs(blobUrl, fileName)
  }

  setTimeout(() => {
    window.URL.revokeObjectURL(blobUrl)
  }, 0)

  return blobUrl
}

export default (base64Data: string, mimeType: string, fileName: string) => {
  const blob = base64ToBlob(base64Data, mimeType)

  saveBlob(blob, fileName)
}
